/* eslint-disable camelcase, max-len */
import { AppProps } from "next/app";
import HEAD from "next/head";
import React from "react";

import "../styles/globals.scss";

declare global {
    export interface Window {
        sp_user_logged_in: boolean;
        sp_user_id: number | null;
    }
}

function MyApp({ Component, pageProps }: AppProps) {
    return (
        <>
            <HEAD>
                {/* charset|viewport|http-equiv */}
                <meta name="viewport" content="width=device-width, initial-scale=1" />
            </HEAD>
            <Component {...pageProps} />
        </>
    );
}

export default MyApp;
